import styled from 'styled-components'

export const Wrapper = styled.div`
  .column {
    button {
      margin-left: 5px !important;
    }
    span {
      line-height: 30px;
    }
  }
`
